import { infoIcon } from "assets/icons";
import { useState } from "react";

const ParamsPopUp = ({ content }: { content?: any }) => {
    return (
        <div>
            <div className="modal fade shadow-lg p-4 rounded" id="Params-Info" aria-labelledby="statusModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-white">
                        {/* <div className="modal-header pt-4 pb-3 text-center border-0">
                            <h5 className="modal-title ml-6">
                            <i className="fa-solid fa-circle-info fa-3x d-block mr-0 ml-8 pl-7 pop-up-info"></i>
                            </h5>
                        </div> */}
                        <div className="modal-body p-4 text-center">
                            <p className='mb-0'><img src={infoIcon} alt='info-icon' className="mr-2" />{content}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ParamsPopUp
